import api from "./api";
import { handleError } from "./utils";

const isBrowser = typeof window !== `undefined`;

const getInstitutions = async () => {
    if (!isBrowser) return false;

    return await api
        .get(`/landing/clients/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getFaqs = async (queryString) => {
    if (!isBrowser) return false;

    return await api
        .get(`/faqs/?${queryString}`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getCodeTheNationFaqs = async () => {
    if (!isBrowser) return false;

    return await api
        .get(`/faqs/caps/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getReviews = async () => {
    if (!isBrowser) return false;

    return await api
        .get(`/landing/testimonials/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getBlogArticles = async () => {
    if (!isBrowser) return false;

    return await api
        .get(`/blogs/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getBlogArticleDetails = async (slug) => {
    if (!isBrowser) return false;

    return await api
        .get(`/blogs/${slug}/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getRelatedBlogArticles = async (slug) => {
    if (!isBrowser) return false;

    return await api
        .get(`/blogs/${slug}/related/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const likeBlogArticle = async (slug) => {
    if (!isBrowser) return false;

    return await api
        .put(`/blogs/${slug}/like/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getCasetStudyArticleDetails = async (slug) => {
    if (!isBrowser) return false;

    return await api
        .get(`/case_study/${slug}/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const getRelatedCasetStudyArticles = async (slug) => {
    if (!isBrowser) return false;

    return await api
        .get(`/case_study/${slug}/related/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                    data: response.data,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const likeCaseStudyArticle = async (slug) => {
    if (!isBrowser) return false;

    return await api
        .put(`/case_study/${slug}/like/`)
        .then(function (response) {
            if (response.status === 200) {
                return {
                    status: true,
                };
            }
        })
        .catch(function (error) {
            return handleError(error);
        });
};

const ContentService = {
    getInstitutions,
    getFaqs,
    getReviews,
    getBlogArticles,
    getBlogArticleDetails,
    getRelatedBlogArticles,
    likeBlogArticle,
    getCodeTheNationFaqs,
    getCasetStudyArticleDetails,
    getRelatedCasetStudyArticles,
    likeCaseStudyArticle,
};
export default ContentService;
